var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInternal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66504 6.16504H9.66504M4.66504 9.66504H12.665M7.34879 15.665H13.865C15.5452 15.665 16.3853 15.665 17.027 15.3381C17.5915 15.0504 18.0504 14.5915 18.3381 14.027C18.665 13.3853 18.665 12.5452 18.665 10.865V5.46504C18.665 3.78488 18.665 2.9448 18.3381 2.30307C18.0504 1.73858 17.5915 1.27964 17.027 0.99202C16.3853 0.665039 15.5452 0.665039 13.865 0.665039H5.46504C3.78488 0.665039 2.9448 0.665039 2.30307 0.99202C1.73858 1.27964 1.27964 1.73858 0.99202 2.30307C0.665039 2.9448 0.665039 3.78488 0.665039 5.46504V18.0005C0.665039 18.5334 0.665039 18.7998 0.774268 18.9367C0.869262 19.0557 1.01331 19.1249 1.16558 19.1247C1.34067 19.1245 1.54871 18.9581 1.9648 18.6252L4.35025 16.7169C4.83756 16.327 5.08121 16.1321 5.35253 15.9935C5.59324 15.8705 5.84947 15.7806 6.11425 15.7263C6.41271 15.665 6.72473 15.665 7.34879 15.665Z",
    stroke: "white",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternal);
export default __webpack_public_path__ + "static/media/internal.e905951f536fec63580fbbcc7d378c62.svg";
export { ForwardRef as ReactComponent };